

class ConfigSet {
    public serverHost: string;
    public snackbarDispTime: number;
    public licenseCheck: boolean;
    public debugMode: boolean;

    constructor() {
        this.serverHost = process.env.REACT_APP_API_SERVER_URL || '';
        this.snackbarDispTime = Number(process.env.REACT_APP_SC_QUICK3D_SNACKBAR_DISP_TIME) || 3000;
        this.licenseCheck = process.env.REACT_APP_LICENSE_CHECK === 'true';
        this.debugMode = process.env.REACT_APP_DEBUG_MODE === 'true';
    }
}


export const config = new ConfigSet();
